import React, { useState,useEffect,useCallback } from "react";
import "../Myprojects.css"
import api from "views/auth/Api";
import {columnsDataComplex} from "../../tables/variables/columnsData";
import ModelsTable from "../../tables/components/ModelsTable";
import { TbFile3D } from "react-icons/tb";
import { FaRegWindowClose } from "react-icons/fa";
import { FILES_URL } from '../../../../configs/AppConfig';
import { API_BASE_URL } from '../../../../configs/AppConfig';
import { message, Modal } from 'antd';
import Loader from "components/loader";



const Model3d = ({data}) => {
      const [tableData , setTableData] = useState([]);
      const [selected, setSelected] = useState(null);
      const [printers, setPrinters] = useState([]);
      const [showPrinters, setShowPrinters] = useState(false);
      const [loadingPrinters, setLoadingPrinters] = useState(false);
      const [requestingPrinterId, setRequestingPrinterId] = useState(null);
      const [selectedGcodeId, setSelectedGcodeId] = useState(null);
      // const [imgs, setImgs] = useState([]);

      useEffect(() => {
              setTableData(data.model3d?.modelParts)
              // setImgs(data.model3d?.imgs)
        }, [data]);

    const selectPlate =(id)=>{
      setSelected(id);
        console.log("Selected Plate ID:", id);
      }

    const selectedGcode = (id) => {
      setSelectedGcodeId(id);
              console.log("Selected Gcode ID:", id);
    };

    const fetchPrinters = useCallback(async (showLoader) => {
      if (showLoader) setLoadingPrinters(true);
      await api.get(`${API_BASE_URL}printer/school-printers`)
        .then(function (response) {
          setPrinters(Array.isArray(response.data) ? response.data : response.data?.printers || []);
        }).catch(error => {
          console.log("handlesubmit error for blog get ", error)
        }).finally(() => {
          if (showLoader) setLoadingPrinters(false);
        });
    }, []);

    const handlePrint = async () => {
      setShowPrinters(true);
      await fetchPrinters(true);
      }

      // Keep printer heartbeat/online state and print progress live while the popup is open
      useEffect(() => {
        if (!showPrinters) return;
        const interval = setInterval(() => {
          fetchPrinters(false);
        }, 5000);
        return () => clearInterval(interval);
      }, [showPrinters, fetchPrinters]);

      const closePrinters = () => {setShowPrinters(false);
        setPrinters([]);
      };

      const printerLabel = (printer) =>
        printer.name || printer.printerName || printer.printerId || printer.id || "Printer";

      const getPrinterId = (printer) => printer.printerId || printer.id;

      const getPrinterProgress = (printer) =>
        printer.progress ?? printer.printProgress ?? printer.percent ?? printer.completion;

      const updatePrinterState = (printerId, newState) => {
        setPrinters((prev) =>
          prev.map((p) =>
            getPrinterId(p) === printerId ? { ...p, status: newState, state: newState } : p
          )
        );
      };

      const confirmPrint = (printer) => {
        Modal.confirm({
          className: 'printerConfirmModal',
          centered: true,
          title: 'Clear the build plate',
          content: 'Make sure the build plate is completely clear before starting this print.',
          okText: 'Confirm & Print',
          cancelText: 'Cancel',
          onOk: () => requestPrint(printer),
        });
      };

      const requestPrint = async (printer) => {
        if (!selectedGcodeId) {
          message.error('Gcode file not found');
          return;
        }
        const printerId = getPrinterId(printer);
        setRequestingPrinterId(printerId);
        updatePrinterState(printerId, "busy");
        await api.post(`${API_BASE_URL}printer/${printerId}/download`, {
          attachmentId: selectedGcodeId,
        })
          .then(() => {
            message.success('Print request sent to the printer');
          }).catch(error => {
            console.log("handlesubmit error for printer print request ", error);
            updatePrinterState(printerId, "error");
            message.error(error.response?.data?.message || 'Failed to send print request');
          }).finally(() => {
            setRequestingPrinterId(null);
          });
      };

      const printerState = (printer) => {
        if (printer.status) return printer.status;
        if (printer.state) return printer.state;
        if (typeof printer.isOnline === "boolean") return printer.isOnline ? "online" : "offline";
        if (typeof printer.online === "boolean") return printer.online ? "online" : "offline";
        return "unknown";
      };

      const printerStateClass = (state) => {
        const s = String(state).toLowerCase();
        if (["online", "idle", "ready", "standby"].includes(s)) return "printerStateOnline";
        if (["printing", "busy", "downloading", "paused", "complete"].includes(s)) return "printerStateBusy";
        if (["offline", "error", "disconnected"].includes(s)) return "printerStateOffline";
        return "printerStateUnknown";
      };

      const printerStateLabel = (state) => {
        const s = String(state).toLowerCase();
        if (["printing", "paused", "complete", "busy", "downloading"].includes(s)) return "Busy";
        return state;
      };

      const popPrinters = () => (
        <div className="teacherModal printerModalOverlay" onClick={closePrinters}>
          <div className="popPrinters" onClick={(e) => e.stopPropagation()}>
            <div className="printerModalHeader">
              <div>
                <h4>School Printers</h4>
                <p className="printerModalSubtitle">
                  {loadingPrinters
                    ? "Checking printer status..."
                    : `${printers.length} printer${printers.length === 1 ? "" : "s"} found`}
                </p>
              </div>
              <FaRegWindowClose className="windowClose" onClick={closePrinters} />
            </div>

            {loadingPrinters ? (
              <div className="printerLoaderWrap">
                <Loader loading={loadingPrinters} />
              </div>
            ) : printers.length === 0 ? (
              <p className="printerEmptyState">No printers found for this school.</p>
            ) : (
              <div className="printerList">
                {printers.map((printer, i) => {
                  const stateClass = printerStateClass(printerState(printer));
                  const printerId = getPrinterId(printer);
                  const isAvailable = stateClass === "printerStateOnline";
                  const isBusy = stateClass === "printerStateBusy";
                  const isRequesting = requestingPrinterId === printerId;
                  return (
                    <div className="printerRow" key={printerId || i}>
                      <div className="printerInfo">
                        <span className={`printerDot ${stateClass}`} />
                        <span className="printerName">{printerLabel(printer)}</span>
                      </div>
                      <div className="printerActions">
                        <span className={`printerStateBadge ${stateClass}`}>
                          {printerStateLabel(printerState(printer))}
                        </span>
                        {isAvailable ? (
                          <button
                            className={`printerSendBtn ${isRequesting ? "printerSendBtnBusy" : ""}`}
                            disabled={isRequesting}
                            onClick={() => confirmPrint(printer)}
                          >
                            <TbFile3D className="printerSendBtnIcon" />
                            {isRequesting ? "Sending..." : "Print"}
                          </button>
                        ) : isBusy ? (
                          <button className="printerSendBtn printerSendBtnBusy" disabled>
                            <TbFile3D className="printerSendBtnIcon" />
                            {isRequesting
                              ? "Sending..."
                              : (() => {
                                  const s = String(printerState(printer)).toLowerCase();
                                  const label = s.charAt(0).toUpperCase() + s.slice(1);
                                  const progress = getPrinterProgress(printer);
                                  return s === "printing" && progress != null
                                    ? `${label} ${progress}%`
                                    : label;
                                })()}
                          </button>
                        ) : null}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      );
  return (
    <div>
      {/* <Header /> */}
      <div className="model3d-container">
        <div className="model3d-cards" >
           {tableData.map(img =>
                      <div className={selected === img.id ? "model3d-cardSelected" : "model3d-card"} style={{backgroundImage:`url(${FILES_URL}${img.img?.url})`}}>
                      </div>
                   )}
        </div>
  <div className="table3D">
        <ModelsTable
          columnsData={columnsDataComplex}
          tableData={tableData}
          selectPlate ={selectPlate}
          selectedGcode={selectedGcode}
        />
     <button className={`print3D ${!selected ? "opacity-50 cursor-not-allowed" : ""}`} onClick={handlePrint} disabled={!selected}>
       <TbFile3D className="printIcon"/>
       <span>Print</span>
     </button>
   </div>

        </div>
        {showPrinters ? popPrinters() : null}
    </div>
  );
};

export default Model3d;
